<canvas #canvas class="signature-canvas"></canvas>
